const buildBody = (value) => {
    if (typeof value === 'string' ||
        value instanceof URLSearchParams ||
        value instanceof FormData ||
        value instanceof Blob ||
        value instanceof ArrayBuffer ||
        value === undefined ||
        value === null)
        return value;
    return JSON.stringify(value);
};
export default buildBody;
//# sourceMappingURL=buildBody.js.map